import React from "react";
import { Slide, Fade } from "react-awesome-reveal";
import { socialLinks } from "../../config/Social";
import { ReactComponent as GithubIcon } from "../../assets/icons/github.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/icons/linkedin.svg";
import { ReactComponent as XIcon } from "../../assets/icons/x.svg";
import { ReactComponent as UpworkIcon } from "../../assets/icons/upwork.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/icons/youtube.svg";
import "./Left.css";

const icons = {
  github: GithubIcon,
  linkedin: LinkedinIcon,
  twitter: XIcon,
  upwork: UpworkIcon,
  youtube: YoutubeIcon,
};

const Left = () => {
  return (
    <div className="left">
      <div className="main-links">
        <Slide direction="up" cascade>
          <ul>
            <Fade duration={200} cascade direction="up">
              {Object.entries(socialLinks).map(([key, social]) => {
                const IconComponent = icons[key];
                return (
                  social.url && IconComponent && (
                    <li key={key}>
                      <a href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                        <IconComponent />
                      </a>
                    </li>
                  )
                );
              })}
            </Fade>
          </ul>
          <div className="vline"></div>
        </Slide>
      </div>
    </div>
  );
};

export default Left;
